import React from "react";
import { withRouter } from "react-router-dom";

const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};
const token = localStorage.getItem('token');
const AuthVerify = (props) => {
    props.history.listen(() => {
        // const user = JSON.parse(localStorage.getItem("user"));

        if (token) {
           
            const decodedJwt = parseJwt(token);

            if (decodedJwt.exp * 1000 < Date.now()) {
                props.logOut();
            }
        }
    });

    return <div></div>;
};

export default withRouter(AuthVerify);